<div class="form-item" [ngClass]="'form-field-'+fieldSubmission.field.type">
  <div class="field-label">
    <div>
      <strong>{{fieldSubmission.field.label}}</strong>
      <span class="form-ast" [hidden]="!fieldSubmission.field.mandatory"> * </span>
    </div>
  </div>
  <div class="field-tag-main"  [ngClass]="{'invalid-field': (!valid && fieldSubmission.field.mandatory)}">
    <div class="field-fill-tag" [ngClass]="{'completed': selectedTag}">
      <div class="fill-overlay"></div>
      <div class="field-fill-single-tag-selector"
        *ngIf="availableLabels && availableLabels.length > 0; else loadingTags">
        <span class="filter-subtitle"><em>{{fieldSubmission.field.options.category.name}}</em></span>
        <core-custom-forms-helpers-search-filters-labels-group [labels]="availableLabels"
          (choose)="onTagSelect($event)"></core-custom-forms-helpers-search-filters-labels-group>
      </div>
    </div>
    <div class="field-fill-single-tag-selected" *ngIf="selectedTag">
      <core-label-action [label]="selectedTag" (actionClick)="remove($event)"></core-label-action>
    </div>
  </div>
  <ng-template #loadingTags>
    <div class="loader tags-lists"> 
      <div class="dimmed">
        <div class="dimmed_title"></div>
        <div class="dimmed_noflex">
          <div class="dimmed_subtitle"></div>
        </div>
      </div>
    </div>
  </ng-template>

</div>